export class VaultTypes {
    static readonly PASSWORD_VAULT_PRIVATE: number = 0;
    static readonly PASSWORD_VAULT_SHARED_ORGANIZATION: number = 1;
    static readonly PASSWORD_VAULT_ORGANIZATION_ARCHIVE: number = 2;

}